module.exports = __webpack_public_path__ + "static/media/refrigeratorDefault.1d1733be.png";